import React from "react";
import "./ChargeCoin.css";
import BackBtn from "../../Components/BackBtn/BackBtn";

export default function ChargeCoin() {
  return (
    <div className="gymBg bgContainer">
      <div className="blurOverlay">
        <div className="pageWrapper">
          <div className="pageHeader centeredFlex">
            <BackBtn />
          </div>
          <div className="chargeCoinHeader horizontalBorder">
            لطفا میزان شارژ سکه را انتخاب کنید:
          </div>
          <div className="chargeCoinContent centeredFlex responsiveWidth">
            <span>به زودی...</span>
            <img src="/images/bigCoin.svg" alt="coin icon" />
            <p>از صبوری شما ممنونم</p>
          </div>
        </div>
      </div>
    </div>
  );
}
